import { GetterTree, MutationTree, ActionTree } from "vuex";
import { RootState, UserState } from "@/store/types.ts";
import axios from "axios";
import moment from "moment";
import router from "@/router";

export const data: UserState = {
  user: null,
  timeout: moment(),
  rules: [],
};

export const getters: GetterTree<UserState, RootState> = {
  currentUser(state) {
    return { ...state.user };
  },
  isLoggedIn(state) {
    return state.user != null;
  },
};

export const mutations: MutationTree<UserState> = {
  createSession(state, session) {
    state.user = session;
    state.rules = session.rules;
    state.timeout = moment().add(20, "minute");
    if (router.currentRoute.path === "/signin") router.push("/");
  },

  destroySession(state) {
    state.user = null;
    state.rules = [];
    state.timeout = moment();
    router.push("/signin");
  },
};

export const actions: ActionTree<UserState, RootState> = {
  login({ commit }, credentials) {
    axios
      .post("/auth/login", credentials, { withCredentials: true })
      .then(response => {
        response.data.rules = response.data.permissions.rules || [];
        commit("createSession", response.data);
      })
      .catch(error => {
        console.error(error);
        router.push("/signin");
      });
  },

  logout({ commit }) {
    axios
      .get("/auth/logout")
      .then(() => {
        commit("destroySession");
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  },

  authorize({ state, commit }, next) {
    const { user: usr, timeout } = state;
    const now = moment.now();
    if (timeout.isAfter(now)) {
      next();
    } else {
      axios
        .get("/user/authorize", {
          withCredentials: true,
        })
        .then(response => {
          commit("createSession", response.data);
          next();
        })
        .catch(() => {
          commit("destroySession");
          next("/signin");
        });
    }
  },

  changePassword(context, password) {
    if (context.state.user) {
      return axios
        .post(
          "/user/change_password",
          {
            username: context.state.user.username,
            password,
          },
          {
            withCredentials: true,
          }
        )
        .catch(error => {
          console.error(error);
          throw error;
        });
    }
    throw new Error("No user in state");
  },
};

export const user = {
  state: data,
  getters,
  mutations,
  actions,
};
